import { render, staticRenderFns } from "./communicationAddDialog.vue?vue&type=template&id=ca92e2ae&scoped=true"
import script from "./communicationAddDialog.vue?vue&type=script&lang=js"
export * from "./communicationAddDialog.vue?vue&type=script&lang=js"
import style0 from "./communicationAddDialog.vue?vue&type=style&index=0&id=ca92e2ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca92e2ae",
  null
  
)

export default component.exports